import React from "react";
import VillageCalendarsTemplate from "../../components/templates/villageCalendars/villageCalendarsTemplate";

const VillageCalendars: React.FC = () => {
  return <VillageCalendarsTemplate />;
};

export default VillageCalendars;
